import { SECTIONS } from '../constants';
import { hasAtLeastOneValidLink } from './referenceLinks';

export const isQuestionAnswered = (question, value) => {
    if (question.kind === 'reference_links') {
        return hasAtLeastOneValidLink(value);
    }
    return (value || '').trim().length > 0;
};

export const countAnsweredQuestions = (answers = {}) =>
    SECTIONS.reduce(
        (total, section) =>
            total + section.questions.filter(question => isQuestionAnswered(question, answers[question.id])).length,
        0
    );
